export { OrderStatus, PaymentStatus } from '@wix/ambassador-ecom-v1-order/types';
export let RestaurantsOrderStatus = /*#__PURE__*/function (RestaurantsOrderStatus) {
  RestaurantsOrderStatus["PENDING_APPROVAL"] = "Pending";
  RestaurantsOrderStatus["ACCEPTED"] = "Accepted";
  RestaurantsOrderStatus["READY"] = "Ready";
  RestaurantsOrderStatus["OUT_FOR_DELIVERY"] = "In_Delivery";
  RestaurantsOrderStatus["FULFILLED"] = "Fulfilled";
  return RestaurantsOrderStatus;
}({});
export let OperationalOrderStatus = /*#__PURE__*/function (OperationalOrderStatus) {
  OperationalOrderStatus["PENDING_APPROVAL"] = "Pending";
  OperationalOrderStatus["ACCEPTED"] = "Accepted";
  OperationalOrderStatus["READY"] = "Ready";
  OperationalOrderStatus["OUT_FOR_DELIVERY"] = "In_Delivery";
  return OperationalOrderStatus;
}({});
export let EcomOrderStatus = /*#__PURE__*/function (EcomOrderStatus) {
  EcomOrderStatus["CANCELED"] = "Canceled";
  return EcomOrderStatus;
}({});
export let OrderDescriptionLineType = /*#__PURE__*/function (OrderDescriptionLineType) {
  OrderDescriptionLineType["SPECIAL_REQUESTS"] = "Special requests";
  OrderDescriptionLineType["VARIANT"] = "Choice";
  return OrderDescriptionLineType;
}({});
//# sourceMappingURL=index.js.map